import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import 'index.css';
import store from 'shared/store';
import App from 'app/App';

import * as serviceWorker from 'serviceWorker';

const app = (
  <Provider store={store}>
    <App />
  </Provider >
);

ReactDOM.render(app, document.getElementById('root'));

//document.body.addEventListener('touchmove', e => e.preventDefault(), {passive: false});

// note - we're using sw-build.js & sw-template.js
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
